import React from "react";
import { Table, Popconfirm, Divider, Typography } from "antd";

const { Text } = Typography;

const PineLabsTable = ({ data = [], loading = false, openModal, deleteMachine, onPageChange, modify, deleteAccess }) => {
  const columns = [
    {
      title: "Machine ID",
      dataIndex: "machineId",
      key: "machineId",
      render: (text) => text || "-",
    },
    {
      title: "Branch",
      dataIndex: "branch",
      key: "branch",
      render: (text) => text?.name || "-",
    },
    {
      title: "Client ID",
      dataIndex: "clientId",
      key: "clientId",
      render: (text) => text || "-",
    },
    {
      title: "Merchant ID",
      dataIndex: "merchantId",
      key: "merchantId",
      render: (text) => text || "-",
    },
    {
      title: "Store ID",
      dataIndex: "storeId",
      key: "storeId",
      render: (text) => text || "-",
    },
    {
      title: "MDR",
      dataIndex: "MBR",
      key: "MBR",
      render: (text) => text || "-",
    },
    {
      title: "User IDs",
      dataIndex: "userIds",
      key: "userIds",
      render: (userIds) => {
        if (!Array.isArray(userIds) || userIds.length === 0) return "-";
        return userIds.map((u) => u.name).join(", ");
      },
    },
    {
      title: "Actions",
      key: "actions",
      width: 200,
      render: (text, record) => (
        <div>
          {modify ? (
            <span
              className="linkylink"
              size="small"
              onClick={(e) => {
                e.stopPropagation();
                openModal(record.id, "edit");
              }}
            >
              Modify
            </span>
          ) : (
            <span></span>
          )}

          {modify && deleteAccess ? <Divider type="vertical" /> : null}

          {deleteAccess ? (
            <Popconfirm
              title="Are you sure you want to delete this machine?"
              onConfirm={(e) => {
                e.stopPropagation();
                deleteMachine(record.id);
              }}
              okText="Yes"
              cancelText="No"
            >
              <span className="linkylink" onClick={(e) => e.stopPropagation()}>
                Delete
              </span>
            </Popconfirm>
          ) : (
            <span></span>
          )}

          {!modify && !deleteAccess ? (
            <Text strong disabled>
              No Access Given
            </Text>
          ) : (
            <span></span>
          )}
        </div>
      ),
    },
  ];

  return (
    <Table
      rowKey={(record) => record.id}
      loading={loading}
      dataSource={data}
      columns={columns}
      pagination={{
        pageSize: 10,
        onChange: (page, pageSize) => {
          if (onPageChange) onPageChange(page, pageSize);
        },
      }}
      onRow={(record) => ({
        onClick: () => openModal(record.id, "view"),
      })}
    />
  );
};

export default PineLabsTable;
